<template>
  <section>
    <h1>Setup Election</h1>

    <v-form class="mt-5 mr-1" :disabled="creating" v-model="valid" @submit.prevent="saveElection">
      <v-row>
        <v-col cols="12">
          <v-autocomplete v-model="association" item-text="description"
            prepend-inner-icon="mdi-account-supervisor-circle-outline" item-value="id" :items="associations"
            :rules="rules.required" hide-details filled clearable label="Association or Group"></v-autocomplete>
        </v-col>
        <v-col cols="12" lg="4">
          <v-text-field label="Date of Election" hide-details prepend-inner-icon="mdi-calendar-outline"
            :rules="rules.required" filled type="date" single-line v-model="date"></v-text-field>
        </v-col>
        <v-col cols="12" lg="4">
          <v-text-field full-width hide-details label="Start of Election" prepend-inner-icon="mdi-clock-start"
            :rules="rules.required" filled type="time" v-model="start" hint="Time is in 24H format"></v-text-field>
        </v-col>
        <v-col cols="12" lg="4">
          <v-text-field full-width hide-details label="End of Election" prepend-inner-icon="mdi-clock-end"
            :rules="rules.required" filled type="time" v-model="end" hint="Time is in 24H format"></v-text-field>
        </v-col>
        <v-col cols="12" lg="4">
          <v-autocomplete v-model="session" item-text="name" item-value="id" :items="sessions"
            prepend-inner-icon="mdi-school-outline" :rules="rules.required" filled clearable label="Session"
            hide-details></v-autocomplete>
        </v-col>
        <v-col cols="12" lg="8">
          <v-text-field v-model="description" prepend-inner-icon="mdi-information-outline" filled clearable
            label="Description" hide-details></v-text-field>
        </v-col>
        <v-col cols="12" lg="4">
          <v-checkbox v-model="future_sessions" label="Include future sessions" hide-details></v-checkbox>

          <v-checkbox v-model="use_portal_email" label="Use only portal email" hide-details></v-checkbox>
        </v-col>
      </v-row>

      <v-btn :loading="creating" :disabled="!valid || creating" type="submit" class="mt-7" color="green" outlined large>
        Save election
      </v-btn>
    </v-form>
  </section>
</template>

<script>
import { required } from "../../tools/rules"

export default {
  data: () => ({
    association: null,
    date: null,
    start: null,
    end: null,
    session: null,
    future_sessions: false,
    use_portal_email: false,
    description: null,

    valid: false,
    creating: false,

    rules: { required },

    sessions: [],
    associations: [],
  }),

  methods: {
    loadSessions() {
      this.$axios.get("/sessions").then(async ({ data: sessions }) => {
        this.sessions = [...sessions].reverse()
      })
    },

    loadAssociationsAndGroups() {
      this.$axios.get("/associations").then(async ({ data: associations }) => {
        this.associations = associations
      })
    },

    saveElection() {
      const data = {
        association: this.association,
        date: this.date,
        start: this.start,
        end: this.end,
        session: this.session,
        future_sessions: this.future_sessions,
        use_portal_email: this.use_portal_email,
        description: this.description,
      }

      this.$axios({
        url: "/elections",
        method: "POST",
        data,
      })
        .then(() => {
          this.$router.push("elections")
          this.$bus.$emit("snackbar", {
            type: "success",
            message: "Election setup successful",
          })
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Election setup failed",
          })
        })
        .finally(() => {
          this.creating = false
        })
    },
  },

  mounted() {
    this.loadSessions()
    this.loadAssociationsAndGroups()
    this.$bus.$on("associations.updated", this.loadAssociationsAndGroups)
  },
}
</script>
